import { createi18nInstance } from '@pletly/common';
import { resources } from './locales/index';

export const defaultNS = 'feature-about';

const i18n = createi18nInstance({
	resources,
	defaultNS,
});

export default i18n;
